export default "__VITE_ASSET__hhE4S3Ek__"